module.exports = __webpack_public_path__ + "static/media/ki.ca42f7e3.svg";